import isNil from './is-nil';
import isArray from './is-array';
var firstValue = function (data, name) {
    var rst = null;
    for (var i = 0; i < data.length; i++) {
        var obj = data[i];
        var value = obj[name];
        if (!isNil(value)) {
            if (isArray(value)) {
                rst = value[0]; // todo è¿éæ¯å¦åºè¯¥ä½¿ç¨éå½ï¼è°ç¨ firstValue @ç»äº
            }
            else {
                rst = value;
            }
            break;
        }
    }
    return rst;
};
export default firstValue;
//# sourceMappingURL=first-value.js.map